import { useMutation } from 'react-query';
import { toast } from 'react-toastify';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { httpService } from '../../../services/http.service';
import { IMoveMoneyReviewResponse, IServerErrorResponse } from '../../../types';
import LiliNotification, { LiliNotificationType } from '../../../DesignSystem/LiliNotification/LiliNotification';
import { flattenServerErrorResponse } from '../../../helpers/errors.helper';
import { LiliToastDefaultConfig } from '../../../DesignSystem/LiliToast/LiliToast';
import { endpointManager } from '../../../services/endpoint.service';

interface IWireOutReview {
  supplierId: string;
  billId?: string;
  amount: number;
  reason: string;
  reasonDescription: string;
}

export const postInternationalWireOutReview = () => {
  const { postInternationalWireOutReviewUrl } = endpointManager();
  const { t } = useTranslation();

  return useMutation(
    'postInternationalWireOutReview',
    async ({
      supplierId, amount, reason, reasonDescription, billId,
    }: IWireOutReview): Promise<IMoveMoneyReviewResponse> => {
      const url = postInternationalWireOutReviewUrl(billId);
      const res = await httpService.post(
        url,
        {
          supplierId,
          amount,
          reason,
          reasonDescription: reasonDescription || null,
        },
      );
      return res.data.mfaActionData;
    },
    {
      onError: (error: IServerErrorResponse) => {
        const { localizedMessage } = flattenServerErrorResponse(error);
        const isManualError = [4730, 91107].includes(error?.response?.data?.errors?.[0]?.code);
        toast(<LiliNotification undismissable type={LiliNotificationType.ERROR} text={isManualError ? t('LOGIN_ERROR_POPUP_HEADER') : localizedMessage} id='vendorDetailsError' />, { ...LiliToastDefaultConfig });
      },
    },
  );
};
